import Axios from './base';

export const GetIncidentReports = (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `IncidentReports${queryString ? `?${queryString}` : ''}`;
    return Axios().get(url);
}

export const GetIncidentReportById = (id) => Axios().get('IncidentReports/' + id);

export const AddIncidentReport = (entity) => Axios('Incident Report Submitted').post('IncidentReports', entity);

export const UpdateIncidentReport = (id, entity) => Axios('Incident Report Updated').put('IncidentReports/' + id, entity);
